import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { BrowserMultiFormatReader } from '@zxing/browser';
import LoadingButton from 'components/loading_button/loading_button';

const TicketScanner = ({ enterCodeManually, onScanFinished }) => {
  const SCANNER_STATUS = {
    normal: 'normal',
    initializing: 'initializing',
    scanning: 'scanning',
  };
  const [status, setStatus] = useState(SCANNER_STATUS.normal);
  const videoRef = useRef(null);
  const canceled = useRef(false);
  const controller = useRef(null);

  const stopScanner = () => {
    canceled.current = true;
    controller.current?.stop();
    setStatus(SCANNER_STATUS.normal);
  };

  const onScan = () => {
    setStatus(SCANNER_STATUS.initializing);
    canceled.current = false;
    const codeReader = new BrowserMultiFormatReader();
    codeReader.decodeFromVideoDevice(
      undefined,
      'scanner-stream-video',
      async (result, err, control) => {
        controller.current = control;
        if (canceled.current) {
          return;
        }
        setStatus(SCANNER_STATUS.scanning);
        if (result) {
          stopScanner();
          onScanFinished(result.text);
        }
      }
    );
  };

  return (
    <>
      <h4 className="text-black">Scan your ticket barcode</h4>
      {status === SCANNER_STATUS.normal && (
        <div
          role="button"
          className="bg-light border rounded d-flex"
          onClick={onScan}
        >
          <div className="m-auto my-7">
            <i className="fa-light fa-camera-retro text-grey fa-3x" />
          </div>
        </div>
      )}
      {(status === SCANNER_STATUS.scanning ||
        status === SCANNER_STATUS.initializing) && (
        <div className="border rounded d-flex">
          <video
            id="scanner-stream-video"
            ref={videoRef}
            className="ticket-history--video"
            autoPlay
            muted
          />
        </div>
      )}

      <div className="d-grid gap-2">
        <LoadingButton
          className="btn btn-primary w-100 text-white"
          disabled={status === SCANNER_STATUS.initializing}
          loading={status === SCANNER_STATUS.initializing}
          onClick={() => {
            if (status === SCANNER_STATUS.scanning) {
              setStatus(SCANNER_STATUS.normal);
              stopScanner();
            } else {
              onScan();
            }
          }}
        >
          {status === SCANNER_STATUS.initializing && 'Initializing...'}
          {status === SCANNER_STATUS.scanning && 'Stop scanning'}
          {status === SCANNER_STATUS.normal && 'Scan with camera'}
        </LoadingButton>
        <button
          type="button"
          className="btn btn-link button-link text-small"
          onClick={enterCodeManually}
        >
          Enter code manually
        </button>
      </div>
    </>
  );
};

export default TicketScanner;
TicketScanner.propTypes = {
  enterCodeManually: PropTypes.func.isRequired,
  onScanFinished: PropTypes.func.isRequired,
};
